"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../../../elements/button/Button");
var _TickOutlined = require("../../../icons/TickOutlined");
var _emailMeModule = _interopRequireDefault(require("../email-me/email-me.module.scss"));
var _emailMeSuccessModule = _interopRequireDefault(require("./email-me-success.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var EmailMeSuccess = function EmailMeSuccess(_ref) {
  var _ref$shouldShowContin = _ref.shouldShowContinueShoppingCTA,
    shouldShowContinueShoppingCTA = _ref$shouldShowContin === void 0 ? true : _ref$shouldShowContin,
    modalClose = _ref.modalClose;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _emailMeSuccessModule.default['email-me-success'],
    "data-testid": "component-email-me-success",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _emailMeSuccessModule.default['email-me-success__icon'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TickOutlined.TickOutlined, {
        size: "medium"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _emailMeSuccessModule.default['email-me-success__content'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        className: _emailMeModule.default.heading,
        children: "We\u2019ve just sent you a confirmation email"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: "We\u2019ll contact you when this product becomes available."
      })]
    }), shouldShowContinueShoppingCTA && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
      className: _emailMeSuccessModule.default['email-me-success__button'],
      "data-testid": "component-email-me-success-CTA",
      onClick: modalClose,
      children: "Continue Shopping"
    })]
  });
};
EmailMeSuccess.propTypes = {
  modalClose: _propTypes.default.func.isRequired,
  showContinueShoppingCTA: _propTypes.default.bool
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(EmailMeSuccess);